import React from 'react';
import { useSelector } from 'umi';
import { mobilePageConfig } from './mobilePageConfig';
import { pcPageConfig } from './pcPageConfig';
import { nightgalePageConfig } from './nightgalePageConfig';
import CommonPageRender from '@/pages/dashboard/components/PageContainer/CommonPageRender';
import { casualPageConfig } from './casualPageConfig';

const reqParams = '/engagement/register';
const Register = () => {
  const dataFrame = useSelector((state: any) => {
    return state?.dashboard?.currentGame?.data_frame || 'mobile';
  });
  const pageMap: any = {
    default: mobilePageConfig,
    mobile: mobilePageConfig,
    pc: pcPageConfig,
    pc_inflexion: nightgalePageConfig,
    casual: casualPageConfig,
  };
  return (
    <>
      <CommonPageRender reqParams={reqParams} pageConfigInit={pageMap?.[dataFrame] || pageMap?.default} />
    </>
  );
};

export default Register;

